import { css } from '@linaria/core';
import { styled } from '@linaria/react';

import { ButtonIconGhost } from '~shared/ui/atoms/Buttons/ButtonGhost/Icon';
import { MqTablet } from '~theme/media';

export const modal = css`
	overflow: auto;
	flex-direction: column;
`;

export const CloseButton = styled(ButtonIconGhost)`
	position: absolute;
	top: calc(1rem + var(--safe-top));
	right: 1rem;
`;

export const UserInfoContent = styled.form`
	position: relative;
	display: flex;
	width: calc(100% - 4rem);
	height: 100%;
	min-height: 46rem;

	max-height: 70rem;
	flex-direction: column;
	padding: 2.4rem;
	border-radius: var(--radius-l);
	margin-right: 2rem;
	margin-left: 2rem;
	background: var(--color-grey-10-solid);
	gap: var(--gap-x5);

	& > *:first-child {
		margin-left: -0.8rem;
	}

	${MqTablet} {
		width: 46rem;
		padding: 3.2rem 3.2rem 2.4rem;
		margin-right: auto;
		margin-left: auto;
	}
`;

export const styledTabs = css`
	width: fit-content;
`;

export const StyledWrapper = styled.div`
	display: flex;
	overflow: auto;
	flex-direction: column;
	flex-grow: 1;
	padding-right: 1rem;
	padding-bottom: 2rem;
	gap: var(--gap-x4);
`;
